import React from 'react';
export class ChanelQuantity extends React.Component {
  render() {
    return (
      <div className='qty-wrapper'>
        <span className='label'>Quantity</span>
        <select
          onChange={this.props.updateQuantity}
          className={`quantity form-control ${this.props.className ? this.props.className : ''}`}
          maxLength='2'
          value={this.props.quantity}
          data-minimum={this.props.minimumQuantity ? this.props.minimumQuantity : 1}
          data-maximum={this.props.maximumQuantity ? this.props.maximumQuantity : 3}
          title='Please select a valid quantity'
          id='quantityInput'
          name='quantity'
        >
          <option value='1'>1</option>
          <option value='2'>2</option>
          <option value='3'>3</option>
        </select>
      </div>
    );
  }
}

export default ChanelQuantity;
